module.exports = __webpack_public_path__ + "static/media/Hala Al-Jaber.5dbca23e.png";